export default {
  "2020": {
    "drama": [
      {
        "id": 76331,
        "won": true
      },
      {
        "id": 65494,
        "won": false
      },
      {
        "id": 90282,
        "won": false
      },
      {
        "id": 66292,
        "won": false
      },
      {
        "id": 72750,
        "won": false
      }
    ],
    "comedy": [
      {
        "id": 73107,
        "won": false
      },
      {
        "id": 67070,
        "won": true
      },
      {
        "id": 81290,
        "won": false
      },
      {
        "id": 70796,
        "won": false
      },
      {
        "id": 83127,
        "won": false
      }
    ],
    "limited": [
      {
        "id": 87108,
        "won": true
      },
      {
        "id": 82744,
        "won": false
      },
      {
        "id": 81131,
        "won": false
      },
      {
        "id": 80443,
        "won": false
      },
      {
        "id": 91275,
        "won": false
      }
    ]
  },
  "2021": {
    "drama": [
      {
        "id": 65494,
        "won": true
      },
      {
        "id": 69740,
        "won": false
      },
      {
        "id": 82816,
        "won": false
      },
      {
        "id": 82856,
        "won": false
      },
      {
        "id": 81354,
        "won": false
      }
    ],
    "comedy": [
      {
        "id": 97546,
        "won": false
      },
      {
        "id": 93812,
        "won": false
      },
      {
        "id": 61662,
        "won": true
      },
      {
        "id": 82596,
        "won": false
      },
      {
        "id": 93287,
        "won": false
      }
    ],
    "limited": [
      {
        "id": 87739,
        "won": true
      },
      {
        "id": 89905,
        "won": false
      },
      {
        "id": 90705,
        "won": false
      },
      {
        "id": 83851,
        "won": false
      },
      {
        "id": 99581,
        "won": false
      }
    ]
  },
  "2022": {
    "drama": [
      {
        "id": 93405,
        "won": false
      },
      {
        "id": 76331,
        "won": true
      },
      {
        "id": 90282,
        "won": false
      },
      {
        "id": 96677,
        "won": false
      },
      {
        "id": 79084,
        "won": false
      }
    ],
    "comedy": [
      {
        "id": 124101,
        "won": true
      },
      {
        "id": 107113,
        "won": false
      },
      {
        "id": 97546,
        "won": false
      },
      {
        "id": 93812,
        "won": false
      },
      {
        "id": 95215,
        "won": false
      }
    ],
    "limited": [
      {
        "id": 80039,
        "won": true
      },
      {
        "id": 110695,
        "won": false
      },
      {
        "id": 64513,
        "won": false
      },
      {
        "id": 111141,
        "won": false
      },
      {
        "id": 115004,
        "won": false
      }
    ]
  },
  "2023": {
    "drama": [
      {
        "id": 95396,
        "won": false
      },
      {
        "id": 65494,
        "won": false
      },
      {
        "id": 94997,
        "won": true
      },
      {
        "id": 60059,
        "won": false
      },
      {
        "id": 69740,
        "won": false
      }
    ],
    "comedy": [
      {
        "id": 125935,
        "won": true
      },
      {
        "id": 136315,
        "won": false
      },
      {
        "id": 124101,
        "won": false
      },
      {
        "id": 107113,
        "won": false
      },
      {
        "id": 119051,
        "won": false
      }
    ],
    "limited": [
      {
        "id": 111803,
        "won": true
      },
      {
        "id": 155537,
        "won": false
      },
      {
        "id": 113988,
        "won": false
      },
      {
        "id": 122066,
        "won": false
      },
      {
        "id": 114925,
        "won": false
      }
    ]
  },
  "2024": {
    "drama": [
      {
        "id": 203857,
        "won": false
      },
      {
        "id": 76331,
        "won": true
      },
      {
        "id": 157744,
        "won": false
      },
      {
        "id": 65494,
        "won": false
      },
      {
        "id": 100088,
        "won": false
      },
      {
        "id": 90282,
        "won": false
      }
    ],
    "comedy": [
      {
        "id": 125935,
        "won": false
      },
      {
        "id": 136315,
        "won": true
      },
      {
        "id": 107113,
        "won": false
      },
      {
        "id": 73107,
        "won": false
      },
      {
        "id": 222023,
        "won": false
      },
      {
        "id": 97546,
        "won": false
      }
    ],
    "limited": [
      {
        "id": 154385,
        "won": true
      },
      {
        "id": 155421,
        "won": false
      },
      {
        "id": 95555,
        "won": false
      },
      {
        "id": 60622,
        "won": false
      },
      {
        "id": 216089,
        "won": false
      },
      {
        "id": 117303,
        "won": false
      }
    ]
  },
  "2025": {
    "drama": [
      {
        "id": 203857,
        "won": false
      },
      {
        "id": 95480,
        "won": false
      },
      {
        "id": 126308,
        "won": true
      },
      {
        "id": 118642,
        "won": false
      },
      {
        "id": 93405,
        "won": false
      },
      {
        "id": 222766,
        "won": false
      }
    ],
    "comedy": [
      {
        "id": 125935,
        "won": false
      },
      {
        "id": 136315,
        "won": false
      },
      {
        "id": 124101,
        "won": true
      },
      {
        "id": 250923,
        "won": false
      },
      {
        "id": 107113,
        "won": false
      },
      {
        "id": 236235,
        "won": false
      }
    ],
    "limited": [
      {
        "id": 241259,
        "won": true
      },
      {
        "id": 147050,
        "won": false
      },
      {
        "id": 225634,
        "won": false
      },
      {
        "id": 94028,
        "won": false
      },
      {
        "id": 194764,
        "won": false
      },
      {
        "id": 46648,
        "won": false
      }
    ]
  },
  "2026": {
    "drama": [
      {
        "id": 250307,
        "won": true
      },
      {
        "id": 203857,
        "won": false
      },
      {
        "id": 225171,
        "won": false
      },
      {
        "id": 95396,
        "won": false
      },
      {
        "id": 95480,
        "won": false
      },
      {
        "id": 111803,
        "won": false
      }
    ],
    "comedy": [
      {
        "id": 247767,
        "won": true
      },
      {
        "id": 125935,
        "won": false
      },
      {
        "id": 136315,
        "won": false
      },
      {
        "id": 124101,
        "won": false
      },
      {
        "id": 250923,
        "won": false
      },
      {
        "id": 107113,
        "won": false
      }
    ],
    "limited": [
      {
        "id": 249042,
        "won": true
      },
      {
        "id": 246386,
        "won": false
      },
      {
        "id": 42009,
        "won": false
      },
      {
        "id": 241405,
        "won": false
      },
      {
        "id": 250504,
        "won": false
      },
      {
        "id": 253376,
        "won": false
      }
    ]
  }
};
